import React from 'react'
import ProdTaskRow from './ProdTaskRow'
import withView from '../../../../cmn/docAutomation/withView';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../../../library/layout/Index";

const ProdTaskList = (props) => {
    const { formObject, viewData, onSelectTask, selectedTask } = props;

    const onRowClick = (rowKey) => {
        // console.log("Debug_1", rowKey);

        if(onSelectTask)onSelectTask(rowKey);
    }

    return (
        <>
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span className="uiInline"><SarasTrans value = "Order Tasks"/></span>
                    </UiTitle>
                    <UiAction>
                        <FormButton formObject={formObject} rowKey="" starIcon={'add'}
                            onlyIcon={true}
                            starIconClassName="uiLink uiIcon"
                            action={{ actionId: "new", actionName: "prodTaskBom", actionParam: {actionType : "addBOMTask"}, containerKey: "popup" }}
                            ></FormButton>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListScroll">
                    {
                        Object.values(viewData ? viewData : {}).sort((a, b) => a.sortKey - b.sortKey).map((row, index) => (
                            <ProdTaskRow formObject={formObject} rowKey={row.rowKey} viewData={row}
                            onRowClick={onRowClick} selectedTask={selectedTask}
                            />
                        ))
                    }
                    </ul>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(ProdTaskList, "prodTaskList", "");